// extracted by mini-css-extract-plugin
export default {"service-list":"_3d1lr3QQc2o7Q__1FhjmRn _1CshOVRjNkRsb4JVr-sYNc","service":"lGO-pnd33-mOEDxECJlSN _2VZMDFa1kxX05Y_Lh_C9tB"};